import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  arrayMove,
  arrayPush,
  arrayRemove,
  arraySwap,
  change,
  formValues,
} from 'redux-form'
import { Grid, Segment, Table } from 'semantic-ui-react'
import ProductBrowser from './ProductBrowser'
import ProductFamilyMemberRow from './ProductFamilyMemberRow'

const mapStateToProps = (state, ownProps) => {
  const { products } = state.product
  const { categories } = state.categories
  return { products, categories }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      arrayPush,
      arraySwap,
      arrayMove,
      arrayRemove,
      change,
    },
    dispatch
  )
}

class ProductFamilyMembers extends React.Component {
  state = {
    dragMarker: {},
  }

  addMember(member) {
    const { products, arrayPush } = this.props //redux
    const { form } = this.props // redux form
    const product = products.find(
      (product) => product.article_number === member
    )
    arrayPush(form, 'family_member_ids', product && product.id)
  }

  moveMember(oldIndex, newIndex) {
    const { form, arrayMove } = this.props // redux
    arrayMove(form, 'family_member_ids', oldIndex, newIndex)
  }

  findMember(dragId) {
    const { products } = this.props // redux form
    const { family_member_ids } = this.props //formValues
    const memberList =
      products.length > 0 && family_member_ids
        ? family_member_ids.map((memberId) =>
            products.find((product) => product.id === memberId)
          )
        : []
    const item = memberList.find((member) => member.article_number === dragId)
    return {
      item,
      index: memberList.indexOf(item),
    }
  }

  getMemberList() {
    const { dragMarker = {} } = this.state
    const { arrayRemove, change, products } = this.props // redux
    const { form } = this.props // redux form
    const { preferred_product_id, family_member_ids } = this.props //formValues

    const memberList =
      products.length > 0 && family_member_ids
        ? family_member_ids.map((memberId) =>
            products.find((product) => product.id === memberId)
          )
        : []
    return memberList.map((product, index) => (
      <ProductFamilyMemberRow
        {...{
          key: index,
          accessory: product,
          index: index,
          dragId: product.article_number,
          unlinkFamilyMember: (index) =>
            arrayRemove(form, 'family_member_ids', index),
          moveItem: (oldIndex, newIndex) => this.moveMember(oldIndex, newIndex),
          findItem: (dragId) => this.findMember(dragId),
          preferred: preferred_product_id === product.id,
          handlePreferred: () =>
            change(
              form,
              'preferred_product_id',
              preferred_product_id === product.id ? -1 : product.id
            ),
          setDragMarker: (dragMarker) => this.setState({ dragMarker }),
          dragMarker: dragMarker,
        }}
      />
    ))
  }

  render() {
    const dark = config.theme.dark
    const { family_member_ids } = this.props //formValues

    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={6}>
            <ComponentHeader
              inline
              title={I18n.t('admin.product.family_members.linked_products')}
            />
            <Segment
              attached
              className={classNames(['payload', dark && 'inverted'])}>
              <Table
                sortable
                compact
                size="small"
                selectable
                singleLine
                basic="very"
                className="spaced">
                <Table.Header>
                  <Table.Row>
                    <Table.Cell
                      colSpan={3}
                      textAlign="right"
                      children={I18n.t(
                        'admin.product.family_members.top_product'
                      )}
                    />
                    <Table.Cell />
                  </Table.Row>
                </Table.Header>
                <Table.Body children={this.getMemberList()} />
              </Table>
            </Segment>
          </Grid.Column>
          <Grid.Column width={6}>
            <ProductBrowser
              {...{
                selectable: 'left',
                form: 'family_member_browser',
                initialValues: {
                  filterActive: true,
                  filterInactive: false,
                  filterArchived: false,
                  filterProduct: true,
                  filterFamily: false,
                  filterFamilyMember: false,
                  filterText: '',
                  categoryFilter: -1,
                },
                exclude: family_member_ids,
                onSelect: (article_number) => this.addMember(article_number),
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

ProductFamilyMembers = formValues('preferred_product_id', 'family_member_ids')(
  ProductFamilyMembers
)
ProductFamilyMembers = connect(mapStateToProps, mapDispatchToProps)(
  ProductFamilyMembers
)
export default ProductFamilyMembers



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductFamilyMembers.jsx